import React from 'react';

import _ from 'lodash';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { push } from 'react-router-redux';

import {
  MODALS,
  TENDERS_LIST_URL,
  TENDER_PARTNER_AVAILABLE_TENDERS_URL
} from 'global-constants';

import { substituteUrl } from 'shared/utils/substituteUrl';

import AutoScrollableForm from 'shared/HOCs/AutoScrollableForm';

import Button from 'shared/components/Button';
import TenderFormFields from 'shared/components/TenderFormFields';
import { openModal } from 'shared/components/Modals/reducer';

import { setActiveTab } from 'pages/EditProfile/ducks';

import { createTender } from 'pages/Tender/Create/ducks';

import styles from './styles.module.scss';

const CREATE_TENDER_FORM = 'createTenderForm';

class CreateTenderForm extends React.Component {
  state = {
    briefPdf: null
  };

  submit = data => {
    const { tenderPartner } = this.props;
    const isTenderPartnerTender = !_.isNil(tenderPartner);

    let extraActions = [
      () => push(substituteUrl(TENDERS_LIST_URL, { activeTab: 'open' })),
      () => openModal({ modalName: MODALS.SUCCESS_CREATE_TENDER_MODAL })
    ];

    if (isTenderPartnerTender) {
      const tenderPartnerSlug = tenderPartner.slug;

      data = { ...data, tender_partner_slug: tenderPartnerSlug };

      extraActions = [
        () =>
          push(
            substituteUrl(TENDER_PARTNER_AVAILABLE_TENDERS_URL, {
              activeTab: 'open'
            })
          )
      ];
    }

    this.props.createTender(CREATE_TENDER_FORM, data, extraActions);
  };

  render() {
    const { invalid, submitting, className, tenderPartner } = this.props;

    const primaryColor = _.get(tenderPartner, 'primary_color');
    const secondaryColor = _.get(tenderPartner, 'secondary_color');

    return (
      <form
        className={classnames(styles.formWrapper, className)}
        onSubmit={this.props.handleSubmit(this.submit)}>
        <div className={styles.contactInfo}>
          <div className={styles.title}>
            Find a PropTech solution to your problem. Fast and Free.
          </div>
          <div className={styles.description}>
            Take the right step, and get in contact with our team directly to
            discuss your procurement needs:
          </div>
          {!_.isEmpty(process.env.REACT_APP_TELEPHONE_NUMBER) && (
            <React.Fragment>
              <p>
                Call us on{' '}
                <a
                  href={`tel:${process.env.REACT_APP_TELEPHONE_NUMBER}`}
                  className={styles.telephone}>
                  {process.env.REACT_APP_TELEPHONE_NUMBER}
                </a>
              </p>
              <p>
                <i>or</i>
              </p>
            </React.Fragment>
          )}
          <a className={styles.emailUsBtn} href="mailto:help@unissu.com">
            Email Us
          </a>
        </div>
        <TenderFormFields
          tenderPartner={tenderPartner}
          formName={CREATE_TENDER_FORM}
        />
        <div
          className={styles.additionalInfo}
          style={{ backgroundColor: secondaryColor }}>
          <div className={styles.text}>
            <span className={styles.bold}>Have you included everything?</span>{' '}
            Adding as much information as possible will help us find suitable
            PropTech companies faster.
            <br />
            <br />
            Use the list to the right to keep track of what could be included in
            your project brief.
          </div>
          <span /> {/* we use it for the gap */}
          <ul>
            {['Budget', 'Closing Date', 'Sector', 'Technology'].map(item => (
              <li key={`${item}`}>{item}</li>
            ))}
          </ul>
          <ul>
            {['Property Lifecycle', 'Geographical Info'].map(item => (
              <li key={`${item}`}>{item}</li>
            ))}
          </ul>
        </div>
        <div className={styles.btnRow}>
          <Button
            className={styles.saveBtn}
            color="brand-green"
            type="submit"
            disabled={invalid || submitting}
            style={{ backgroundColor: primaryColor }}>
            Create Project
          </Button>
        </div>
      </form>
    );
  }
}

CreateTenderForm = reduxForm({
  form: CREATE_TENDER_FORM
})(AutoScrollableForm(CreateTenderForm));

const mapStateToProps = state => ({});
const mapDispatchToProps = { createTender, setActiveTab };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateTenderForm);
